import { RouterProvider } from "react-router-dom";
import { QueryProvider } from "@/components/providers/query-provider";
import { LoadingIndicator } from "@/components/shared/loading-indicator";
import { CommonAlertDialog } from "@/components/shared/common-alert-dialog";
import { Toaster } from "sonner";
import { router } from "./router";

export function App() {
  return (
    <QueryProvider>
      <RouterProvider router={router} />
      <LoadingIndicator />
      <Toaster />
      <CommonAlertDialog />
    </QueryProvider>
  );
}
